export default __webpack_public_path__ + "static/media/SIDHARTH SHAH.5ac22d7a.jpg";